<template lang="pug">
  .giftcard
    giftcard-links(v-if="['USA', 'APO'].includes($rogue.site.code)")
    swatches.delivery(
      label="Gift Card Delivery Method"
      :required="true"
      v-model="giftcardConfig.delivery"
      :options="deliveryOpts"
    )
    .downloadpdf(
      v-if="giftcardConfig.delivery === 'print'"
      v-html=`__("<strong>Note:</strong> To gift at your convenience, fill out the form below then <a target='_blank' href='{link}'>download the printable PDF Gift Card template</a>. We will email the Gift Code to you to be hand-written on the PDF.", {link: giftcardLink })`)
    swatches.amount(
      label="Gift Card Amount"
      :options="amountOpts"
      :modelValue="giftcardConfig.customAmount !== null ? 'custom' : giftcardConfig.amount"
      @update:modelValue="setGiftPrice($event)"
    )
    giftcard-design(:buy-request="buyRequest")
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useProductStore } from '@/js/stores/productStore'
import { useRogue } from '@/js/services/Rogue'
import GiftcardLinks from './giftcard-links.vue'
import GiftcardDesign from './giftcard-design.vue'
import GIFTCARD_PDFS from './giftcard-pdfs'
import type { BuyRequest, GiftcardMetadata } from '@/js/services/types/order'

const DEFAULT_PDF = 'https://assets.roguefitness.com/image/upload/f_pdf/v1630616983/catalog/Gift%20Cards/printable-pdfs/printable-giftcard_zlt1wd.pdf'

const props = defineProps<{
  buyRequest: BuyRequest
}>()

const rogue = useRogue()
const productStore = useProductStore()

const deliveryOpts = [
  { label: 'Email', value: 'email' },
  { label: 'Print Your Gift', value: 'print' },
]

const product = productStore.products[props.buyRequest.productId]

const amountOpts: { label: string, value: number | string }[] = (product.giftcardData?.amounts || [])
  .map(amnt => ({
    label: rogue.currency(amnt)
      .replace('.00', ''),
    value: amnt as number | string,
  }))
  .concat([{ label: 'Other', value: 'custom' }])

const giftcardConfig = computed(() => props.buyRequest.metadata?.giftcard as GiftcardMetadata)

const giftcardLink = computed(() => {
  const pdfs = GIFTCARD_PDFS[giftcardConfig.value?.design || '']

  return pdfs?.[rogue.site.code] || DEFAULT_PDF
})

function setGiftPrice(val: number | 'custom') {
  if (val === 'custom') {
    giftcardConfig.value.customAmount = giftcardConfig.value.amount
  } else {
    giftcardConfig.value.customAmount = null
    giftcardConfig.value.amount = val
  }
}
</script>
<style lang="scss" scoped>
.downloadpdf {
  margin: $space-s 0;
  font-size: $size-xxs;
}

.amount, .delivery {
  margin-bottom: $space-s;
}

.delivery:deep() {
  .option-count {
    display: none;
  }
  @include not-mobile() {
    .swatches.full .swatch-holder {
      max-width: 33%;
    }
  }
}
</style>
